import React from "react"
const ReviewStarIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M10,0l2.35,7.655L20,7.639l-6.2,4.715L16.18,20,10,15.26,3.82,20,6.2,12.355,0,7.639l7.65.015Z" fill="#fff"/></svg>
    )
}
export default ReviewStarIcon